export enum SelectColors {
  White = 'white',
  Blue = 'blue',
}

export default SelectColors;
